import React from 'react';
import { Modal, View, Text, ActivityIndicator } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import AdminButton from '../AdminButton';
import { ADMIN_COLORS, ADMIN_FONT } from '../../config/theme/adminColors';
import { useModalWidth } from '../../pages/AdminPanel/Products/formStyles';

// Operação em andamento no painel admin (ex.: duplicar categoria) e, ao fim,
// o resultado dela — no mesmo cartão, no centro da tela.
//
// Usa o `Modal` do react-native para cobrir a tela inteira, como o
// ConfirmDeleteModal: o overlay antigo ficava dentro do bloco da categoria,
// escurecia só ele e o spinner na cor do cliente quase sumia; e o AlertBox do
// resultado abria dentro do bloco da categoria original, que a cópia empurra
// para baixo — o "OK" ficava fora da tela.
//
// - Sem `result`: spinner + título + descrição, sem botão (a operação roda no
//   servidor e não dá para cancelar).
// - Com `result`: ícone de sucesso/erro + título + descrição + botão.
const RESULT_STYLES = {
  success: { icon: 'checkmark-circle', color: ADMIN_COLORS.success, soft: ADMIN_COLORS.successSoft, border: ADMIN_COLORS.successBorder },
  error: { icon: 'alert-circle', color: ADMIN_COLORS.danger, soft: ADMIN_COLORS.dangerSoft, border: ADMIN_COLORS.dangerBorder },
};

const ProgressModal = ({ visible, title, description, result, onClose }) => {
  const modalWidth = useModalWidth();
  const resultStyle = result ? RESULT_STYLES[result.variant] || RESULT_STYLES.success : null;
  const shownTitle = result ? result.title : title;
  const shownDescription = result ? result.description : description;

  return (
    <Modal
      visible={!!visible}
      transparent
      animationType="fade"
      onRequestClose={result ? onClose : () => {}}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: 'rgba(17,24,39,0.45)',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20,
        }}
      >
        <View
          accessibilityRole={result ? 'alert' : 'progressbar'}
          accessibilityLabel={shownTitle}
          accessibilityLiveRegion="polite"
          style={{
            width: modalWidth,
            maxWidth: 420,
            backgroundColor: ADMIN_COLORS.surface,
            borderRadius: 16,
            borderWidth: 1,
            borderColor: ADMIN_COLORS.border,
            paddingVertical: 28,
            paddingHorizontal: 24,
            alignItems: 'center',
            boxShadow: '0 12px 32px rgba(16,24,40,0.18)',
          }}
        >
          {resultStyle ? (
            <View
              style={{
                width: 52,
                height: 52,
                borderRadius: 26,
                backgroundColor: resultStyle.soft,
                borderWidth: 1,
                borderColor: resultStyle.border,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Ionicons name={resultStyle.icon} size={28} color={resultStyle.color} />
            </View>
          ) : (
            <ActivityIndicator size="large" color={ADMIN_COLORS.accent} />
          )}
          <Text
            style={{
              fontFamily: ADMIN_FONT,
              fontSize: 18,
              fontWeight: '700',
              color: ADMIN_COLORS.ink,
              textAlign: 'center',
              marginTop: 16,
            }}
          >
            {shownTitle}
          </Text>
          {shownDescription ? (
            <Text
              style={{
                fontFamily: ADMIN_FONT,
                fontSize: 14,
                lineHeight: 20,
                color: ADMIN_COLORS.muted,
                textAlign: 'center',
                marginTop: 8,
              }}
            >
              {shownDescription}
            </Text>
          ) : null}
          {result ? (
            <AdminButton
              title={result.actionLabel || 'OK'}
              onPress={onClose}
              fullWidth
              style={{ marginTop: 20 }}
            />
          ) : null}
        </View>
      </View>
    </Modal>
  );
};

export default ProgressModal;
